import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const indicatorDefaultVariants = {
  "size": "md"
}
const indicatorCompoundVariants = []

const indicatorSlotNames = [
  [
    "root",
    "indicator__root"
  ],
  [
    "dot",
    "indicator__dot"
  ],
  [
    "visual",
    "indicator__visual"
  ]
]
const indicatorSlotFns = /* @__PURE__ */ indicatorSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, indicatorDefaultVariants, getSlotCompoundVariant(indicatorCompoundVariants, slotName))])

const indicatorFn = memo((props = {}) => {
  return Object.fromEntries(indicatorSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const indicatorVariantKeys = [
  "size"
]
const getVariantProps = (variants) => ({ ...indicatorDefaultVariants, ...compact(variants) })

export const indicator = /* @__PURE__ */ Object.assign(indicatorFn, {
  __recipe__: false,
  __name__: 'indicator',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: indicatorVariantKeys,
  variantMap: {
  "size": [
    "sm",
    "md"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, indicatorVariantKeys)
  },
  getVariantProps
})